/**
 * @file: usePrevious.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { usePersistFn } from '@euler/utils/hooks/usePersistFn';
import { useEffect, useRef } from 'react';

export function usePrevious<T>(value: T | undefined) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export const useWatchValue = <T>(
  value: T,
  onChange: (prev: T | undefined, curr: T) => void,
) => {
  const ref = useRef<T>();
  const changeHandler = usePersistFn(onChange);
  useEffect(() => {
    if (ref.current !== value) {
      changeHandler(ref.current, value);
      ref.current = value;
    }
  }, [changeHandler, value]);
};
